
import Datetime from 'vux/src/components/datetime/index.vue'

import mixinComponent from './mixinComponent.js'

export default {
name: 'VyInputDateTime',
components: {
Datetime,
},
mixins: [mixinComponent],
props: {
title: {type: String, default: ''}, // 标题
placeholder: {type: String, default: '请输入'}, // 占位提示文字
required: {type: Boolean, default: false}, // 必填
readonly: {type: Boolean, default: false}, // 只读
disabled: {type: Boolean, default: false}, // 禁用
hide: {type: Boolean, default: false}, // 隐藏
},
computed: {
currentValue: {
get () { return this.value },
set (newValue) { this.$emit('input', newValue) },
},
},
}



// WEBPACK FOOTER //
// ./src/components/basic/VyInputTime.vue